import Layout from '../../views/layouts/index'
const courseRouter = {
  path: '/',
  component: Layout,
  redirect: '/course',
  alwaysShow: true,
  name: 'course',
  children: [
    {
      path: 'course',
      component: () => import('../../views/teachCourse/index'),
      name: 'course_index',
    },
    {
      path: 'course/detail',
      component: () => import('../../views/video/detail/index'),
      name: 'video_detail',
      meta:{activeMenu:'/course'}
    }
  ]
}

export default courseRouter



// WEBPACK FOOTER //
// ./src/router/modules/course.js